import { BiddingDataTypes } from 'interfaces/robot_dashboard';

const BIDDING_STATUS_PRIORITY: Record<string, number> = {
  'Em Disputa': 4,
  Configurada: 3,
  Encerrada: 2,
  Cadastrada: 1,
};

const normalizeKeyPart = (value: string | null): string => (value ?? '').trim();

export const getBiddingUniqueKey = (bidding: BiddingDataTypes): string =>
  [
    bidding.clientId,
    normalizeKeyPart(bidding.portal),
    normalizeKeyPart(bidding.prgCod),
    normalizeKeyPart(bidding.orgName),
  ].join('|');

const getStatusPriority = (status: string): number => BIDDING_STATUS_PRIORITY[status] ?? 0;

const shouldReplaceBidding = (
  current: BiddingDataTypes,
  candidate: BiddingDataTypes,
): boolean => getStatusPriority(candidate.status) > getStatusPriority(current.status);

export const dedupeBiddingsByPortalPrgCodOrgName = (
  biddings: BiddingDataTypes[],
): BiddingDataTypes[] => {
  const byKey = new Map<string, BiddingDataTypes>();

  biddings.forEach((bidding) => {
    const key = getBiddingUniqueKey(bidding);
    const existing = byKey.get(key);

    if (!existing || shouldReplaceBidding(existing, bidding)) {
      byKey.set(key, bidding);
    }
  });

  return Array.from(byKey.values());
};
